import posters from './posters.html';
import banners from './banners.html';
import rollUps from './roll-ups.html';
export default {
  posters,
  banners,
  "roll-ups": rollUps
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/templates/posters-banners-roll-ups/index.js
 **/